import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import type { WidgetDataTableColumn, WidgetDataTableRow } from '../../model/widget-control.model';
import { RichTextDirective } from '../../text/rich-text.directive';

@Component({
  selector: 'dojo-data-table',
  standalone: true,
  imports: [RichTextDirective],
  templateUrl: './data-table.component.html',
  styleUrl: './data-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataTableComponent {
  readonly columns = input.required<WidgetDataTableColumn[]>();
  readonly rows = input.required<WidgetDataTableRow[]>();
  readonly showHeader = input<boolean>(true);
  readonly label = input<string>('');
  readonly resolveValue = input<((path: string) => number | string | undefined) | undefined>(undefined);

  readonly rowHover = output<WidgetDataTableRow>();
  readonly rowLeave = output<WidgetDataTableRow>();

  readonly hoveredRowIndex = signal<number | null>(null);

  onRowMouseEnter(row: WidgetDataTableRow, index: number): void {
    this.hoveredRowIndex.set(index);
    if (row.onHover) {
      this.rowHover.emit(row);
    }
  }

  onRowMouseLeave(row: WidgetDataTableRow, _index: number): void {
    this.hoveredRowIndex.set(null);
    if (row.onLeave) {
      this.rowLeave.emit(row);
    }
  }

  getAlignment(column: WidgetDataTableColumn): string {
    return column.align ?? 'center';
  }
}
